import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'No sabía qué más inventar. Todos los días lo mismo porque era lo único que aceptaba. Con NutriPeques descubrí recetas que nunca se me hubieran ocurrido y mi hijo las pidió dos veces. Dos veces. Yo no lo podía creer.',
    name: 'Sandra',
    desc: 'Mamá de Mateo, 4 años',
    img: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&h=200&fit=crop&crop=face'
  }, {
    quote: 'Mi hija solo quería galletitas, jugos, todo de paquete. Yo ya había resignado. Pensé que era así y listo. Hoy come cosas que antes ni miraba. Sin pelea. Sin llanto. Sin que yo tenga que rogar.',
    name: 'Tatiana',
    desc: 'Mamá de Sofía, 3 años · 🇺🇸 USA',
    img: 'https://images.unsplash.com/photo-1542740348-39501cd6e2b4?w=200&h=200&fit=crop&crop=face'
  }, {
    quote: 'El dulce era su religión. Si no era dulce no lo tocaba. Empecé a aplicar las recetas de NutriPeques y sin darme cuenta empezó a aceptar sabores que antes escupía directamente. No lo puedo explicar pero funciona.',
    name: 'Cecilia',
    desc: 'Mamá de Benjamín, 5 años',
    img: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&h=200&fit=crop&crop=face'
  }, {
    quote: 'Hubo un momento en que me senté y lloré porque no sabía qué más hacer. Sentía que fallaba como mamá porque mi hijo no comía y yo me quedaba sin ideas. NutriPeques me devolvió la confianza en la mesa.',
    name: 'Natalia',
    desc: 'Mamá de Thiago, 3 años · 🇪🇸 España',
    img: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=200&h=200&fit=crop&crop=face'
  }, {
    quote: 'Llegaba el mediodía y ya me daba ansiedad pensar qué le iba a dar. Siempre terminaba haciendo lo mismo porque era lo seguro. Ahora tengo un repertorio de recetas que sé que acepta y la hora de comer dejó de ser un problema.',
    name: 'Luisa',
    desc: 'Mamá de Valentina, 4 años',
    img: 'https://images.unsplash.com/photo-1521252659862-eec69941b071?w=200&h=200&fit=crop&crop=face'
  }, {
    quote: 'Mi hijo era de esos chicos que si la comida tenía color ya la rechazaba. Verde ni hablar. Hoy me pidió repetir una preparación con espinaca. Todavía estoy en shock.',
    name: 'Brenda',
    desc: 'Mamá de Santino, 5 años',
    img: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop&crop=face'
  }, {
    quote: 'Le mostré una receta a mi pediatra y me preguntó dónde la había conseguido. Le conté y me dijo que siguiera así porque los números de hierro de mi hija habían mejorado. Eso me lo dice todo.',
    name: 'Rocío',
    desc: 'Mamá de Emilia, 2 años · 🇦🇷 Argentina',
    img: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop&crop=face'
  }];
  return <section className="py-16 px-4 bg-[#FFF8F0]" data-id="element-559">
      <div className="max-w-lg md:max-w-5xl mx-auto" data-id="element-560">
        <div className="text-center mb-12" data-id="element-561">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" data-id="element-562">
            ESTO DICE QUIEN LO CONOCE
          </h2>
          <div className="w-24 h-1 bg-[#FF8A65] mx-auto rounded-full" data-id="element-563"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-564">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx % 2 * 0.1
        }} className="bg-white p-6 md:p-8 rounded-3xl shadow-sm border border-[#FFE0B2] flex flex-col h-full" data-id="element-565">
              <div className="flex gap-1 mb-4" data-id="element-566">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#FFB300] text-[#FFB300]" data-id="element-567" />)}
              </div>
              <p className="text-gray-700 text-lg italic mb-6 flex-grow" data-id="element-568">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-569">
                <img src={t.img} alt={t.name} className="w-14 h-14 rounded-full object-cover border-2 border-[#FFE0B2]" data-id="element-570" />
                <div data-id="element-571">
                  <div className="font-bold text-gray-900" data-id="element-572">{t.name}</div>
                  <div className="text-sm text-gray-500" data-id="element-573">{t.desc}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}